'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'tilde';
var width = 512;
var height = 512;
var aliases = [63135];
var unicode = '7e';
var svgPathData = 'M122.5 192C90.2 192 64 218.2 64 250.5L64 320c0 17.7-14.3 32-32 32S0 337.7 0 320l0-69.5c0-67.7 54.8-122.5 122.5-122.5 32.5 0 63.7 12.9 86.6 35.9l139 139c11 11 25.9 17.1 41.4 17.1 32.3 0 58.5-26.2 58.5-58.5l0-69.5c0-17.7 14.3-32 32-32s32 14.3 32 32l0 69.5c0 67.7-54.8 122.5-122.5 122.5-32.5 0-63.7-12.9-86.6-35.9l-139-139c-11-11-25.9-17.1-41.4-17.1z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faTilde = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;